export default "__VITE_ASSET__Q8Siv7rI__"